import React from "react";
import { Link } from "react-router-dom";
import { SITE_CONTACT_EMAIL } from "../config/siteContact";
import NewsletterBand from "./NewsletterBand";

export default function AppFooter({ onContact }) {
  return (
    <footer className="mt-auto border-t border-border bg-surface">
      <div className="mx-auto w-full max-w-content px-4 py-8 md:px-8">
        <div className="grid gap-8 md:grid-cols-2">
          <div>
            <h3 className="mb-2 text-xs font-semibold uppercase tracking-wide text-fg-tertiary">Contact</h3>
            <p className="text-sm text-fg-secondary">
              Email:{" "}
              <a href={`mailto:${SITE_CONTACT_EMAIL}`} className="text-accent hover:underline">
                {SITE_CONTACT_EMAIL}
              </a>
            </p>
          </div>
          <div>
            <h3 className="mb-2 text-xs font-semibold uppercase tracking-wide text-fg-tertiary">About Project:</h3>
            <p className="text-sm leading-relaxed text-fg-secondary">
              Oceanic DC Governance offers West Coast environmental screening and regulatory context for oceanic data centers to support safer infrastructure decisions. Official feeds are listed under{" "}
              <Link to="/sources" className="font-medium text-accent hover:underline">
                Sources
              </Link>
              .
            </p>
          </div>
        </div>
        <div className="w-full">
          <NewsletterBand />
        </div>
      </div>
    </footer>
  );
}
